import { ConsumptionModeType } from 'services/consumptionMode/consumptionMode.type';

export enum ChannelId {
    WEB = 2,
}
export type OrderToVerify = {
    restaurantId: number;
    channelId: ChannelId.WEB;
    consumptionMode: ConsumptionModeType.MODE_SIT_IN;
    menuId: number;
    cart: Cart;
    promocode?: string;
    comment?: string;
    tableName?: string;
};

export type OrderVerified = OrderToVerify & {
    recap: OrderRecap;
};

export type OrderCreated = OrderVerified & {
    orderId: number;
};

export type Cart = ProductDTO[];

export type ProductDTO = {
    productId: number;
    quantity: number;
    steps: StepDTO[];
};

export type StepDTO = {
    stepId: number;
    products: ProductDTO[];
};

export type OrderRecap = {
    totalPrice: PriceBreakdown;
    products: ProductRecap[];
};

export type ProductRecap = {
    label: string;
    id: string | number;
    taxRate: number;
    totalPrice: PriceBreakdown;
    unitPrice: PriceBreakdown;
    depth: number;
    quantity: number;
};

export type PriceBreakdown = {
    totalInclTax: number;
    totalExclTax: number;
    totalTax: number;
    totalInclTaxWithDiscount: number;
    totalExclTaxWithDiscount: number;
    totalTaxWithDiscount: number;
    totalInclTaxWithRemise: number;
    totalExclTaxWithRemise: number;
    totalTaxWithRemise: number;
};

export type OrderToCreate = OrderToVerify & {
    expectedAt: string;
    payments: PaymentDTO[];
};

export type PaymentDTO = {
    paymentMethodId: number;
    amount?: number;
    quantity: number;
    currency?: string;
    metadata?: string;
};
